import React, { Component } from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";
import {FormattedMessage} from "react-intl";

import {toggleBathroomVisualizerOpen, toggleUserPopup} from "../../actions/actionFunctions";
import Analytics from "../../analytics";
import UserLoginButton from "./userLoginButton";

class VisualizerButton extends Component {

  goToVisualizer = () => {

    const fabricatorSettings = this.props.fabricatorSettings;
    if (fabricatorSettings.leadCaptureShoppingCart && !UserLoginButton.handleLoginClick({...this.props})) {
      return false;
    }

    Analytics.sendClickEvent("mobile-shopping-cart-visualizer");
    this.props.toggleBathroomVisualizerOpen(true);
    if (!window.location.href.includes("visualizer")) {
      hashHistory.push("visualizer");
    }
  };

  render() {
    return (
      <button className="ui-button3 ui-button3--visualizer" onClick={this.goToVisualizer}>
        <FormattedMessage id="shoppingCart.footer.viewInVisualizerButton1"/>
        <span><FormattedMessage id="shoppingCart.footer.viewInVisualizerButton2"/></span>
      </button>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorSettings: store.fabricatorState.settings
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  toggleUserPopup
})(VisualizerButton);
